import { getDomainUrl } from 'core/utils';

export const FileHelper = {
  DISPLAY_PATH: '/files/index/display/file',

  getDisplayUrl: (fileId?: number | string | null) => {
    if (!fileId) {
      return null;
    }

    return `${getDomainUrl()}${FileHelper.DISPLAY_PATH}/${encodeURIComponent(fileId)}`;
  },
};
